import { useQuoteI18n } from '../quoteI18n'

/**
 * Etichetta del criterio per cui l'offerta è stata selezionata.
 *
 * @param {Object} props
 * @param {string} props.tag - bestPrice | closest | bestBuy | nonCompliant
 */
export function TagBadge({ tag }) {
  const { t } = useQuoteI18n()
  const label = t.tags[tag]
  if (!label) return null

  return (
    <span className="gq-badge" data-tag={tag}>
      {label}
    </span>
  )
}
